import React from "react";
import { getLanguageValue } from "locales/i18n";
import { PAGE_TYPE } from "enums";

import * as commonData from "data/common.data";
import { getCurrentLangName } from "helpers/String.helper";
import { useNavigate } from "react-router-dom";

const KoachSignupDoneComponent = (props: any) => {
    const { accountParams, personalParams, coachParams, profileImageInfo } = props;

    const navigate = useNavigate();
    return (
        <main className="min-h-screen w-full bg-white flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
            <div className="max-w-md w-full space-y-8">
                <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
                    {getLanguageValue(PAGE_TYPE.KOACH, "signupDone.title")}
                </h2>

                {/* 이미지 정보 */}
                <div className="flex justify-center">
                    <div className="w-32 h-32 relative">
                        <div className={`w-full h-full rounded-full overflow-hidden ${profileImageInfo?.url ? 'bg-cover bg-center' : 'bg-gray-100'}`}
                            style={{
                                backgroundImage: `url(${profileImageInfo?.url || "./../../imgs/icons/camera.png"})`
                            }}
                        />
                    </div>
                </div>

                {/* 설명 */}
                <div className="mt-8 space-y-6">
                    <div className="text-center text-gray-700 space-y-4">
                        <p className="text-lg">
                            {getLanguageValue(PAGE_TYPE.KOACH, "signupDone.desc").replace("%NAME%", `${personalParams.firstName} ${personalParams.lastName}`)}
                        </p>
                        <p className="text-base">
                            {getLanguageValue(PAGE_TYPE.KOACH, "signupDone.desc2").replace("%NICKNAME%", accountParams.nickname)}
                        </p>
                        <p className="text-base">
                            {getLanguageValue(PAGE_TYPE.KOACH, "signupDone.desc3")}
                        </p>
                        <p className="text-base font-bold">
                            {personalParams.email}
                        </p>
                        <p className="text-sm text-gray-500">
                            {getLanguageValue(PAGE_TYPE.KOACH, "signupDone.desc4")}
                            <br />
                            {getLanguageValue(PAGE_TYPE.KOACH, "signupDone.desc5")}
                            <br />
                            <em className="text-xs underline font-bold text-gray-500">
                                ({getLanguageValue(PAGE_TYPE.KOACH, "signupDone.desc6")})
                            </em>
                        </p>
                    </div>
                </div>

                <div className="mt-8">
                    <button
                        onClick={(e) => {
                            navigate("/login");
                        }}
                        className="group relative w-full flex justify-center py-3 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-[#CF3688] hover:bg-[#B82F77] focus:outline-none focus:ring-2 focus:ring-[#CF3688]/20 transition duration-150 ease-in-out"
                    >
                        {getLanguageValue(PAGE_TYPE.KOACH, "signupDone.btnLogin")}
                    </button>
                </div>
            </div>
        </main >
    );
};

export default KoachSignupDoneComponent; 